import React, { useEffect, useState } from 'react'
import { connect } from 'react-redux'
import { Breadcrumb, Dropdown } from 'semantic-ui-react'
import { AdminContainer } from '../../styled'
import { rootPath, adminPath, masterDataPath } from 'routes'
import { collapseSideMenu as toggleSideMenu } from 'ducks/app'
import { CompanyDataContainer } from './styled'
import { getCompanies } from 'ducks/options'
import { getCompanyData } from 'ducks/mappingData'
import r from 'reactotron-react-js'

const CompanyData = (props) => {
  const { user, history, companies } = props

  useEffect(() => {
    if (companies.data.length === 0 && companies.loading === false) {
      props.getCompanies();
    }
  }, [])

  useEffect(() => {
    if (!props.collapseMenu) {
      props.toggleSideMenu()
    }

    return () => {
      if (props.collapseMenu && !history.location.pathname.includes('admin')) {
        props.toggleSideMenu()
      }
    }
  })

  useEffect(() => {
    if (user) {
      if (user.isAdmin === false) {
        history.replace(rootPath)
      }
    }
  }, [user])

  const [searchQuery, setSearchQuery] = useState('')

  return (
    <AdminContainer>
      <div className='adminHeader'>
        <div className='headerTitle'>Company Data</div>
        <Breadcrumb 
          icon='right angle' 
          sections={
            [
              { key: 'Admin', content: 'Admin', link: true, onClick: () => history.push(adminPath) },
              { key: 'MasterData', content: 'Master & Mapping Data', link: true, onClick: () => history.push(masterDataPath) },
              { key: 'Company', content: 'Company Data', active: true }
            ]
          }
        />
      </div>
      <CompanyDataContainer>
        <div style={{ width: '100%' }}>
          <Dropdown
            fluid
            search
            selection
            selectOnBlur={false}
            clearable
            placeholder={'Select company'}
            options={companies.data}
            multiple={false}
            allowAdditions={false}
            loading={companies.loading}
            noResultsMessage={'No results found.'}
            onChange={(e, data) => {
              props.getCompanyData(data.value)
            }}
            onClose={(e, data) => {
              setSearchQuery('')
            }}
            searchQuery={searchQuery}
            onSearchChange={(e, data) => {
              if (searchQuery !== data.searchQuery.trimLeft()) {
                setSearchQuery(data.searchQuery.trimLeft())
                data.searchQuery = data.searchQuery.trim()
              }
            }}
          />
        </div>

      </CompanyDataContainer>
    </AdminContainer>
  )
}

const mapStateToProps = (state) => {
  return ({
    user: state.authen.user,
    collapseMenu: state.app.collapseSideMenu,
    companies: state.options.companies,
    plants: state.mappingData.plants
  })
}

const mapDispatchToProps = {
  toggleSideMenu,
  getCompanies,
  getCompanyData
}

export default connect(mapStateToProps, mapDispatchToProps)(CompanyData)